import { COPY_NOTIFICATION_DURATION } from '@/common/constants/notifications.constants';
import { useClipboard } from '@vueuse/core';
import { computed } from 'vue';
import { useI18n } from '@/common/composables/vue-i18n.composable';
import { toString } from 'lodash-es';
import { useNotifications } from '@/common/utils/notifications/notificationsPlugin';

type Props = {
  showNotification?: boolean;
  icon?: string;
};

const useCopy = (props: Props = {}) => {
  const {
    showNotification = true,
    icon = ''
  } = props;

  const { notify } = useNotifications();
  const { copy, copied } = useClipboard({ copiedDuring: COPY_NOTIFICATION_DURATION });
  const { t } = useI18n();

  const copyIcon = computed(() => copied.value ? 'i-check--16' : icon);

  async function copyText(text: string | number, notificationMessage?: string) {
    await copy(toString(text));

    if (showNotification) {
      notify.success({
        message: notificationMessage || t('Copied to clipboard'),
        showClose: false,
        duration: COPY_NOTIFICATION_DURATION,
        skipStore: true
      });
    }
  }

  return {
    copyText,
    copyIcon
  };
};

export default useCopy;
